import React, { useState, useEffect } from 'react';
import { EVENT_DEFINITIONS } from '../../config/events.js';

// ========== ICONS ==========
const Icons = {
  close: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
  dashboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  ),
  media: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
  mobile: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  arrowLeft: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  events: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
    </svg>
  ),
  effects: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
    </svg>
  ),
  tariffs: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="9" y1="21" x2="9" y2="9" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  trash: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),
  edit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
};

// ========== USER ROW COMPONENT ==========
function UserRow({ user, onDelete, onToggleAdmin }) {
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <tr style={{ borderBottom: '1px solid rgba(51, 65, 85, 0.5)' }}>
      <td style={{ padding: '0.75rem 1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #06b6d4, #2563eb)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '0.875rem',
          }}>
            {user.username?.charAt(0).toUpperCase() || '?'}
          </div>
          <div>
            <div style={{ fontWeight: '500', color: '#f1f5f9' }}>{user.username}</div>
            <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{user.email || 'Keine E-Mail'}</div>
          </div>
        </div>
      </td>
      <td style={{ padding: '0.75rem 1rem' }}>
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.375rem',
          padding: '0.25rem 0.625rem',
          borderRadius: '9999px',
          fontSize: '0.75rem',
          fontWeight: '500',
          background: user.is_admin ? 'rgba(245, 158, 11, 0.2)' : 'rgba(51, 65, 85, 0.5)',
          color: user.is_admin ? '#fbbf24' : '#94a3b8',
          border: user.is_admin ? '1px solid rgba(245, 158, 11, 0.3)' : '1px solid rgba(71, 85, 105, 0.3)',
        }}>
          {Icons.shield}
          {user.is_admin ? 'Admin' : 'Benutzer'}
        </span>
      </td>
      <td style={{ padding: '0.75rem 1rem', textAlign: 'right' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <button
            onClick={() => onToggleAdmin(user)}
            title={user.is_admin ? 'Admin-Rechte entziehen' : 'Zum Admin machen'}
            style={{
              padding: '0.5rem',
              borderRadius: '8px',
              background: 'rgba(51, 65, 85, 0.5)',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {Icons.shield}
          </button>
          {showConfirm ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
              <button
                onClick={() => { onDelete(user); setShowConfirm(false); }}
                style={{
                  padding: '0.375rem 0.75rem',
                  borderRadius: '8px',
                  background: 'rgba(239, 68, 68, 0.2)',
                  border: 'none',
                  color: '#f87171',
                  fontSize: '0.75rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                }}
              >
                Löschen
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                style={{
                  padding: '0.375rem 0.5rem',
                  borderRadius: '8px',
                  background: 'rgba(51, 65, 85, 0.5)',
                  border: 'none',
                  color: '#94a3b8',
                  fontSize: '0.75rem',
                  cursor: 'pointer',
                }}
              >
                ✕
              </button>
            </div>
          ) : (
            <button
              onClick={() => setShowConfirm(true)}
              title="Benutzer löschen"
              style={{
                padding: '0.5rem',
                borderRadius: '8px',
                background: 'rgba(51, 65, 85, 0.5)',
                border: 'none',
                color: '#94a3b8',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {Icons.trash}
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

// ========== MAIN ADMIN PANEL ==========
export function EventAdminPanel({ isOpen, onClose, eventSettings = {}, onSettingsChange = () => {}, tariffs = [], onEditTariff, onTariffsChange }) {
  const [activeSection, setActiveSection] = useState('dashboard');
  const [isClosing, setIsClosing] = useState(false);

  // User management state
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [userError, setUserError] = useState(null);
  const [userSuccess, setUserSuccess] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [form, setForm] = useState({ username: '', email: '', password: '', is_admin: false });

  // Demo users for local development
  const demoUsers = [
    { id: 1, username: 'admin', email: 'admin@tef.de', is_admin: true },
    { id: 2, username: 'mueller', email: 'mueller@shop.de', is_admin: false },
    { id: 3, username: 'schmidt', email: 'schmidt@partner.de', is_admin: false },
  ];

  useEffect(() => {
    if (isOpen) {
      if (activeSection === 'users') fetchUsers();
      if (activeSection === 'security') fetchLockouts();
    }
  }, [isOpen, activeSection]);

  // Security / Lockout management state
  const [lockouts, setLockouts] = useState([]);
  const [loadingLockouts, setLoadingLockouts] = useState(false);

  async function fetchLockouts() {
    setLoadingLockouts(true);
    try {
      const res = await fetch('/api/admin/security/lockouts', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json();
      if (data.ok && data.lockouts) {
        const arr = Object.entries(data.lockouts).map(([ip, info]) => ({ ip, ...info }));
        setLockouts(arr);
      }
    } catch (e) {
      console.error('Fehler beim Laden der Lockouts:', e);
    } finally {
      setLoadingLockouts(false);
    }
  }

  async function handleUnlock(ip) {
    try {
      await fetch('/api/admin/security/lockouts/clear', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ key: ip })
      });
      fetchLockouts();
    } catch(e) {}
  }

  async function fetchUsers() {
    setLoadingUsers(true);
    setUserError(null);
    try {
      const res = await fetch('/api/admin/users');
      if (!res.ok) throw new Error('Netzwerkfehler');
      const data = await res.json();
      setUsers(data.users || []);
    } catch (e) {
      // Fallback to demo users for local development
      setUsers(demoUsers);
      setUserError(null); // Don't show error, just use demo data
    } finally {
      setLoadingUsers(false);
    }
  }

  async function createUser(e) {
    e.preventDefault();
    setUserError(null);
    setUserSuccess(null);
    
    try {
      const res = await fetch('/api/admin/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error('Fehler beim Anlegen');
      const j = await res.json();
      if (j && j.user) setUsers(prev => [j.user, ...prev]);
      setForm({ username: '', email: '', password: '', is_admin: false });
      setShowCreateForm(false);
      setUserSuccess('Benutzer erfolgreich angelegt!');
      setTimeout(() => setUserSuccess(null), 3000);
    } catch (err) {
      // Local fallback: add to demo list
      const newUser = {
        id: Date.now(),
        username: form.username,
        email: form.email,
        is_admin: form.is_admin
      };
      setUsers(prev => [newUser, ...prev]);
      setForm({ username: '', email: '', password: '', is_admin: false });
      setShowCreateForm(false);
      setUserSuccess('Benutzer lokal hinzugefügt (wird bei Deployment in DB gespeichert)');
      setTimeout(() => setUserSuccess(null), 4000);
    }
  }

  function handleDeleteUser(user) {
    setUsers(prev => prev.filter(u => u.id !== user.id));
    setUserSuccess(`Benutzer "${user.username}" gelöscht`);
    setTimeout(() => setUserSuccess(null), 3000);
  }

  function handleToggleAdmin(user) {
    setUsers(prev => prev.map(u => 
      u.id === user.id ? { ...u, is_admin: !u.is_admin } : u
    ));
  }

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  const handleEventChange = (eventKey) => {
    onSettingsChange({ ...eventSettings, activeEvent: eventKey });
  };

  const handleIntensityChange = (type, value) => {
    onSettingsChange({ ...eventSettings, [type]: parseInt(value, 10) });
  };

  const allEvents = [
    { key: 'none', ...EVENT_DEFINITIONS.none },
    { key: 'winter', ...EVENT_DEFINITIONS.winter },
    { key: 'christmas', ...EVENT_DEFINITIONS.christmas },
    { key: 'silvester', ...EVENT_DEFINITIONS.silvester },
    { key: 'newyear', ...EVENT_DEFINITIONS.newyear },
    { key: 'carnival', ...EVENT_DEFINITIONS.carnival },
    { key: 'easter', ...EVENT_DEFINITIONS.easter },
    { key: 'summer', ...EVENT_DEFINITIONS.summer },
    { key: 'autumn', ...EVENT_DEFINITIONS.autumn },
    { key: 'blackweek', ...EVENT_DEFINITIONS.blackweek },
    { key: 'blackfriday', ...EVENT_DEFINITIONS.blackfriday },
  ];

  const navGroups = [
    {
      title: 'HAUPTMENÜ',
      items: [
        { id: 'dashboard', label: 'Dashboard', icon: Icons.dashboard },
        { id: 'effects', label: 'Design & Theme', icon: Icons.effects },
        { id: 'events', label: 'Event Designer', icon: Icons.events }
      ]
    },
    {
      title: 'INHALTE',
      items: [
        { id: 'tefdesigner', label: 'TEF Designer', icon: Icons.settings },
        { id: 'tariffs', label: 'Tarife', icon: Icons.tariffs, badge: tariffs.length },
        { id: 'media', label: 'Mediathek', icon: Icons.media },
        { id: 'spielgeld', label: 'Spielgeld', icon: Icons.mobile }
      ]
    },
    {
      title: 'SYSTEM',
      items: [
        { id: 'security', label: 'Sicherheit', icon: Icons.shield },
        { id: 'users', label: 'Benutzer', icon: Icons.users },
        { id: 'settings', label: 'System', icon: Icons.settings }
      ]
    }
  ];

  if (!isOpen && !isClosing) return null;

  // Inline styles für garantierte Funktionalität
  const fullscreenContainerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    background: 'linear-gradient(135deg, #050b14 0%, #0a192f 100%)',
    zIndex: 10000,
    display: 'flex',
    flexDirection: 'row',
    opacity: isClosing ? 0 : 1,
    transition: 'opacity 0.3s ease',
  };

  const sidebarStyle = {
    width: '260px',
    background: 'rgba(12, 25, 41, 0.7)',
    borderRight: '1px solid rgba(34, 211, 238, 0.1)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem 1rem',
  };

  const mainContentStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  };

  return (
    <div style={fullscreenContainerStyle}>
      {/* Sidebar */}
      <div style={sidebarStyle}>
        {/* Brand / Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '2rem', padding: '0 0.5rem' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: 'linear-gradient(135deg, #06b6d4, #2563eb)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 15px rgba(6, 182, 212, 0.4)',
            color: '#fff', fontSize: '1.2rem'
          }}>⚡</div>
          <div>
            <div style={{ fontWeight: 'bold', color: '#fff', fontSize: '0.9rem', lineHeight: 1.2 }}>TEF Admin</div>
            <div style={{ fontSize: '0.65rem', color: '#64748b', letterSpacing: '1px' }}>CONTENT MANAGEMENT</div>
          </div>
        </div>

        {/* Netz-Kompass Badge */}
        <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'center' }}>
          <div style={{
            background: 'rgba(51, 65, 85, 0.3)',
            border: '1px solid rgba(71, 85, 105, 0.5)',
            borderRadius: '4px', padding: '2px 8px', fontSize: '0.65rem', color: '#cbd5e1'
          }}>
            Netz-Kompass
          </div>
        </div>

        {/* Navigation Groups */}
        <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {navGroups.map((group, gIdx) => (
            <div key={gIdx}>
              <div style={{ fontSize: '0.65rem', fontWeight: 'bold', color: '#475569', letterSpacing: '1px', marginBottom: '0.75rem', paddingLeft: '0.5rem' }}>
                {group.title}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                {group.items.map(item => {
                  const isActive = activeSection === item.id;
                  return (
                    <button
                      key={item.id}
                      onClick={() => setActiveSection(item.id)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: '0.75rem',
                        width: '100%', padding: '0.75rem', borderRadius: '8px',
                        background: isActive ? 'linear-gradient(90deg, rgba(6,182,212,0.1) 0%, transparent 100%)' : 'transparent',
                        border: 'none', borderLeft: isActive ? '3px solid #22d3ee' : '3px solid transparent',
                        color: isActive ? '#fff' : '#94a3b8',
                        cursor: 'pointer', transition: 'all 0.2s ease', textAlign: 'left'
                      }}
                    >
                      <div style={{ color: isActive ? '#22d3ee' : '#64748b' }}>{item.icon}</div>
                      <span style={{ fontSize: '0.875rem', fontWeight: isActive ? '600' : '500', flex: 1 }}>{item.label}</span>
                      {item.badge && (
                        <div style={{
                          background: 'rgba(6, 182, 212, 0.2)', color: '#22d3ee',
                          padding: '2px 6px', borderRadius: '12px', fontSize: '0.65rem', fontWeight: 'bold'
                        }}>
                          {item.badge}
                        </div>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Zurück zur App (Bottom) */}
        <button
          onClick={handleClose}
          style={{
            marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem',
            padding: '0.75rem', borderRadius: '8px', background: 'rgba(30, 41, 59, 0.5)',
            border: '1px solid rgba(51, 65, 85, 0.5)', color: '#ef4444',
            cursor: 'pointer', transition: 'all 0.2s ease', width: '100%'
          }}
        >
          <div style={{ color: '#ef4444' }}>{Icons.arrowLeft}</div>
          <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>Zurück zur App</span>
        </button>
      </div>

      {/* Main Content Area */}
      <div style={mainContentStyle}>
        {/* Topbar */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '1rem 2rem', background: 'rgba(12, 25, 41, 0.4)',
          borderBottom: '1px solid rgba(34, 211, 238, 0.1)', backdropFilter: 'blur(10px)'
        }}>
          {/* Left: Breadcrumbs & Sync */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#64748b', fontSize: '0.875rem' }}>
              {Icons.dashboard}
              <span>Admin</span>
              <span style={{ color: '#334155' }}>/</span>
              <span style={{ color: '#f1f5f9', fontWeight: '600' }}>
                {navGroups.flatMap(g => g.items).find(i => i.id === activeSection)?.label || 'Panel'}
              </span>
            </div>
            
            {/* Live-Sync Badge */}
            <div style={{
              display: 'flex', alignItems: 'center', gap: '0.375rem',
              padding: '0.25rem 0.75rem', borderRadius: '9999px',
              background: 'rgba(16, 185, 129, 0.1)', border: '1px solid rgba(16, 185, 129, 0.3)',
              color: '#34d399', fontSize: '0.75rem', fontWeight: '600'
            }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#34d399', boxShadow: '0 0 8px #34d399' }} />
              Live-Sync
            </div>
          </div>

          {/* Right: Search & Actions */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {/* Search Input */}
            <div style={{ position: 'relative' }}>
              <input type="text" placeholder="Suchen... (Panels, Einstellungen, Tarife)" style={{
                background: 'rgba(30, 41, 59, 0.5)', border: '1px solid rgba(51, 65, 85, 0.5)',
                padding: '0.5rem 1rem 0.5rem 2.5rem', borderRadius: '8px', color: '#fff',
                fontSize: '0.875rem', outline: 'none', width: '300px'
              }} />
              <div style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
            </div>

            {/* Theme Toggle */}
            <button style={{
              width: '36px', height: '36px', borderRadius: '8px', background: 'rgba(30, 41, 59, 0.5)',
              border: '1px solid rgba(51, 65, 85, 0.5)', color: '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
            }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
            </button>

            {/* Vorschau */}
            <button style={{
              display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', borderRadius: '8px',
              background: 'rgba(30, 41, 59, 0.5)', border: '1px solid rgba(51, 65, 85, 0.5)', color: '#cbd5e1',
              fontSize: '0.875rem', fontWeight: '500', cursor: 'pointer'
            }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              Vorschau
            </button>

            {/* Speichern Button */}
            <button onClick={handleClose} style={{
              display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', borderRadius: '8px',
              background: 'linear-gradient(135deg, #06b6d4, #2563eb)', border: 'none', color: '#fff',
              fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer', boxShadow: '0 4px 15px rgba(6, 182, 212, 0.4)'
            }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
              SPEICHERN
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '2rem' }}>
          
          {/* ========== DASHBOARD SECTION ========== */}
          {activeSection === 'dashboard' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
              {/* Header */}
              <div>
                <h2 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>Guten Abend</h2>
                <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.5rem 0 0 0' }}>Überblick über die TEF Promoter Konfiguration</p>
              </div>

              {/* Stats Row */}
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '200px', padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3b82f6' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/></svg>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', lineHeight: 1 }}>{tariffs.length || 83}</div>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8', letterSpacing: '1px', marginTop: '0.25rem', fontWeight: '600' }}>TARIFE</div>
                    </div>
                  </div>
                </div>

                <div style={{ flex: 1, minWidth: '200px', padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(14, 165, 233, 0.1)', border: '1px solid rgba(14, 165, 233, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0ea5e9' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', lineHeight: 1, textTransform: 'capitalize' }}>
                        {eventSettings.activeEvent && eventSettings.activeEvent !== 'none' ? eventSettings.activeEvent : 'Keins'}
                      </div>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8', letterSpacing: '1px', marginTop: '0.25rem', fontWeight: '600' }}>EVENT</div>
                    </div>
                  </div>
                </div>

                <div style={{ flex: 1, minWidth: '200px', padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(168, 85, 247, 0.1)', border: '1px solid rgba(168, 85, 247, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a855f7' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><path d="M12 2v20M17 5l-10 14M22 12H2M19 17L5 7"/></svg>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', lineHeight: 1 }}>{((eventSettings.snowIntensity > 0 ? 1 : 0) + (eventSettings.bubbleIntensity > 0 ? 1 : 0)) * 5 || 10}</div>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8', letterSpacing: '1px', marginTop: '0.25rem', fontWeight: '600' }}>EFFEKTE</div>
                    </div>
                  </div>
                </div>

                <div style={{ flex: 1, minWidth: '200px', padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid rgba(16, 185, 129, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', lineHeight: 1 }}>6</div>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8', letterSpacing: '1px', marginTop: '0.25rem', fontWeight: '600' }}>SEGMENTE</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Main Content Row */}
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                
                {/* Schnellaktionen */}
                <div style={{ flex: 1, minWidth: '300px', padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#f1f5f9', margin: '0 0 1.5rem 0' }}>Schnellaktionen</h3>
                  <div style={{ display: 'flex', gap: '1rem' }}>
                    <button style={{ flex: 1, padding: '1.5rem 1rem', borderRadius: '12px', background: 'rgba(30, 41, 59, 0.6)', border: '1px solid rgba(51, 65, 85, 0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', transition: 'all 0.2s' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                      </div>
                      <span style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '500' }}>Seite öffnen</span>
                    </button>
                    <button style={{ flex: 1, padding: '1.5rem 1rem', borderRadius: '12px', background: 'rgba(30, 41, 59, 0.6)', border: '1px solid rgba(51, 65, 85, 0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', transition: 'all 0.2s' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(14, 165, 233, 0.1)', color: '#0ea5e9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><polyline points="1 4 1 10 7 10"/><polyline points="23 20 23 14 17 14"/><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/></svg>
                      </div>
                      <span style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '500' }}>Cache leeren</span>
                    </button>
                    <button style={{ flex: 1, padding: '1.5rem 1rem', borderRadius: '12px', background: 'rgba(30, 41, 59, 0.6)', border: '1px solid rgba(51, 65, 85, 0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', transition: 'all 0.2s' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(168, 85, 247, 0.1)', color: '#a855f7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                      </div>
                      <span style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '500' }}>Backup</span>
                    </button>
                  </div>
                </div>

                {/* Segmente */}
                <div style={{ flex: 1, minWidth: '300px', padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#f1f5f9', margin: '0 0 1.5rem 0' }}>Segmente</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {[
                      { name: 'Mobile', val: 34, color: '#0ea5e9' },
                      { name: 'Blue', val: 5, color: '#3b82f6' },
                      { name: 'Prepaid', val: 5, color: '#3b82f6' },
                      { name: 'MyHome', val: 15, color: '#0ea5e9' },
                      { name: 'Kombivorteil', val: 22, color: '#0ea5e9' },
                      { name: 'Superselect', val: 2, color: '#3b82f6' }
                    ].map(seg => (
                      <div key={seg.name} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <span style={{ width: '80px', fontSize: '0.75rem', color: '#cbd5e1', fontWeight: '500' }}>{seg.name}</span>
                        <div style={{ flex: 1, height: '6px', background: 'rgba(51, 65, 85, 0.5)', borderRadius: '3px', overflow: 'hidden' }}>
                          <div style={{ width: `${(seg.val / 34) * 100}%`, height: '100%', background: `linear-gradient(90deg, ${seg.color}, #38bdf8)`, borderRadius: '3px' }}></div>
                        </div>
                        <span style={{ width: '20px', textAlign: 'right', fontSize: '0.75rem', color: '#f1f5f9', fontWeight: '600' }}>{seg.val}</span>
                      </div>
                    ))}
                  </div>
                </div>

              </div>

              {/* System Row */}
              <div style={{ padding: '1.5rem', borderRadius: '16px', background: 'rgba(30, 41, 59, 0.4)', border: '1px solid rgba(51, 65, 85, 0.5)' }}>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#f1f5f9', margin: '0 0 1.5rem 0' }}>System</h3>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', background: 'rgba(15, 23, 42, 0.5)', borderRadius: '8px', border: '1px solid rgba(51, 65, 85, 0.3)' }}>
                    <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Version</span>
                    <span style={{ fontSize: '0.875rem', color: '#f1f5f9', fontWeight: '600' }}>v2.0</span>
                  </div>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', background: 'rgba(15, 23, 42, 0.5)', borderRadius: '8px', border: '1px solid rgba(51, 65, 85, 0.3)' }}>
                    <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Schnee</span>
                    <span style={{ fontSize: '0.875rem', color: '#f1f5f9', fontWeight: '600' }}>{eventSettings.snowIntensity || 50}%</span>
                  </div>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', background: 'rgba(15, 23, 42, 0.5)', borderRadius: '8px', border: '1px solid rgba(51, 65, 85, 0.3)' }}>
                    <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Blasen</span>
                    <span style={{ fontSize: '0.875rem', color: '#f1f5f9', fontWeight: '600' }}>{eventSettings.bubbleIntensity || 30}%</span>
                  </div>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', background: 'rgba(15, 23, 42, 0.5)', borderRadius: '8px', border: '1px solid rgba(51, 65, 85, 0.3)' }}>
                    <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Gradient</span>
                    <div style={{ width: '32px', height: '16px', borderRadius: '8px', background: '#2563eb', position: 'relative' }}>
                      <div style={{ position: 'absolute', right: '2px', top: '2px', width: '12px', height: '12px', borderRadius: '50%', background: '#fff' }}></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          )}

          {/* ========== USERS SECTION ========== */}
          {activeSection === 'users' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                <div>
                  <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>Benutzerverwaltung</h2>
                  <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.25rem 0 0 0' }}>Verwalte Zugänge und Berechtigungen</p>
                </div>
                <button
                  onClick={() => setShowCreateForm(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.625rem 1rem',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #06b6d4, #2563eb)',
                    color: '#fff',
                    fontWeight: '500',
                    border: 'none',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(6, 182, 212, 0.3)',
                  }}
                >
                  {Icons.plus}
                  Neuer Benutzer
                </button>
              </div>

              {/* Success/Error Messages */}
              {userSuccess && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '1rem',
                  borderRadius: '12px',
                  background: 'rgba(16, 185, 129, 0.1)',
                  border: '1px solid rgba(16, 185, 129, 0.3)',
                  color: '#34d399',
                }}>
                  {Icons.check}
                  {userSuccess}
                </div>
              )}
              {userError && (
                <div style={{
                  padding: '1rem',
                  borderRadius: '12px',
                  background: 'rgba(239, 68, 68, 0.1)',
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                  color: '#f87171',
                }}>
                  {userError}
                </div>
              )}

              {/* Create Form */}
              {showCreateForm && (
                <div style={{
                  padding: '1.5rem',
                  borderRadius: '16px',
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(51, 65, 85, 0.5)',
                }}>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '1rem' }}>Neuen Benutzer anlegen</h3>
                  <form onSubmit={createUser} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#cbd5e1', marginBottom: '0.375rem' }}>Benutzername *</label>
                      <input
                        type="text"
                        value={form.username}
                        onChange={e => setForm({ ...form, username: e.target.value })}
                        required
                        placeholder="z.B. mueller"
                        style={{
                          width: '100%',
                          padding: '0.625rem 1rem',
                          borderRadius: '12px',
                          background: 'rgba(15, 23, 42, 0.5)',
                          border: '1px solid #334155',
                          color: '#fff',
                          fontSize: '0.875rem',
                          outline: 'none',
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#cbd5e1', marginBottom: '0.375rem' }}>E-Mail</label>
                      <input
                        type="email"
                        value={form.email}
                        onChange={e => setForm({ ...form, email: e.target.value })}
                        placeholder="z.B. mueller@shop.de"
                        style={{
                          width: '100%',
                          padding: '0.625rem 1rem',
                          borderRadius: '12px',
                          background: 'rgba(15, 23, 42, 0.5)',
                          border: '1px solid #334155',
                          color: '#fff',
                          fontSize: '0.875rem',
                          outline: 'none',
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#cbd5e1', marginBottom: '0.375rem' }}>Passwort *</label>
                      <input
                        type="password"
                        value={form.password}
                        onChange={e => setForm({ ...form, password: e.target.value })}
                        required
                        placeholder="Sicheres Passwort"
                        style={{
                          width: '100%',
                          padding: '0.625rem 1rem',
                          borderRadius: '12px',
                          background: 'rgba(15, 23, 42, 0.5)',
                          border: '1px solid #334155',
                          color: '#fff',
                          fontSize: '0.875rem',
                          outline: 'none',
                        }}
                      />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={form.is_admin}
                          onChange={e => setForm({ ...form, is_admin: e.target.checked })}
                          style={{ width: '18px', height: '18px', accentColor: '#f59e0b' }}
                        />
                        <span style={{ color: '#cbd5e1' }}>Administrator-Rechte</span>
                      </label>
                    </div>
                    <div style={{ gridColumn: '1 / -1', display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
                      <button
                        type="submit"
                        style={{
                          padding: '0.625rem 1.5rem',
                          borderRadius: '12px',
                          background: 'linear-gradient(135deg, #06b6d4, #2563eb)',
                          color: '#fff',
                          fontWeight: '500',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        Benutzer anlegen
                      </button>
                      <button
                        type="button"
                        onClick={() => setShowCreateForm(false)}
                        style={{
                          padding: '0.625rem 1.5rem',
                          borderRadius: '12px',
                          background: 'rgba(51, 65, 85, 0.5)',
                          color: '#cbd5e1',
                          fontWeight: '500',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        Abbrechen
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {/* Users Table */}
              <div style={{
                borderRadius: '16px',
                background: 'rgba(30, 41, 59, 0.3)',
                border: '1px solid rgba(51, 65, 85, 0.5)',
                overflow: 'hidden',
              }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid rgba(51, 65, 85, 0.5)', background: 'rgba(30, 41, 59, 0.5)' }}>
                      <th style={{ textAlign: 'left', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>Benutzer</th>
                      <th style={{ textAlign: 'left', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>Rolle</th>
                      <th style={{ textAlign: 'right', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>Aktionen</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingUsers ? (
                      <tr>
                        <td colSpan={3} style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>
                          Lade Benutzer...
                        </td>
                      </tr>
                    ) : users.length === 0 ? (
                      <tr>
                        <td colSpan={3} style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>
                          Keine Benutzer vorhanden
                        </td>
                      </tr>
                    ) : (
                      users.map(user => (
                        <UserRow 
                          key={user.id} 
                          user={user} 
                          onDelete={handleDeleteUser}
                          onToggleAdmin={handleToggleAdmin}
                        />
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Info Box */}
              <div style={{
                padding: '1rem',
                borderRadius: '12px',
                background: 'rgba(59, 130, 246, 0.1)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                color: '#93c5fd',
                fontSize: '0.875rem',
              }}>
                <strong>💡 Hinweis:</strong> Diese Benutzer werden nach dem Deployment in der PostgreSQL-Datenbank auf dem TEF-Server gespeichert. 
                Lokale Änderungen dienen zur Vorschau.
              </div>
            </div>
          )}

          {/* ========== SECURITY SECTION ========== */}
          {activeSection === 'security' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>Sicherheit & IP-Sperren</h2>
                <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.25rem 0 0 0' }}>Verwalte blockierte IPs und Rate Limits</p>
              </div>
              
              <div style={{
                borderRadius: '16px',
                background: 'rgba(30, 41, 59, 0.3)',
                border: '1px solid rgba(51, 65, 85, 0.5)',
                overflow: 'hidden',
              }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid rgba(51, 65, 85, 0.5)', background: 'rgba(30, 41, 59, 0.5)' }}>
                      <th style={{ textAlign: 'left', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>IP Adresse / User</th>
                      <th style={{ textAlign: 'left', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>Fehlversuche</th>
                      <th style={{ textAlign: 'left', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>Status</th>
                      <th style={{ textAlign: 'right', padding: '0.75rem 1rem', fontSize: '0.875rem', fontWeight: '600', color: '#cbd5e1' }}>Aktion</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingLockouts ? (
                      <tr>
                        <td colSpan={4} style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>Lade Daten...</td>
                      </tr>
                    ) : lockouts.length === 0 ? (
                      <tr>
                        <td colSpan={4} style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>Keine Einträge vorhanden. Alle IPs sind frei.</td>
                      </tr>
                    ) : (
                      lockouts.map((item) => (
                        <tr key={item.ip} style={{ borderBottom: '1px solid rgba(51, 65, 85, 0.5)' }}>
                          <td style={{ padding: '0.75rem 1rem', color: '#f1f5f9', fontWeight: '500' }}>{item.ip}</td>
                          <td style={{ padding: '0.75rem 1rem', color: '#94a3b8' }}>{item.count}</td>
                          <td style={{ padding: '0.75rem 1rem' }}>
                            {item.permanent ? (
                              <span style={{ color: '#ef4444', fontWeight: '600', fontSize: '0.75rem', padding: '0.2rem 0.5rem', background: 'rgba(239, 68, 68, 0.1)', borderRadius: '4px' }}>Dauerhaft gesperrt</span>
                            ) : item.lockedUntil && item.lockedUntil > Date.now() ? (
                              <span style={{ color: '#f59e0b', fontWeight: '600', fontSize: '0.75rem', padding: '0.2rem 0.5rem', background: 'rgba(245, 158, 11, 0.1)', borderRadius: '4px' }}>
                                Gesperrt bis {new Date(item.lockedUntil).toLocaleTimeString()}
                              </span>
                            ) : (
                              <span style={{ color: '#10b981', fontWeight: '600', fontSize: '0.75rem', padding: '0.2rem 0.5rem', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '4px' }}>Zählt (frei)</span>
                            )}
                          </td>
                          <td style={{ padding: '0.75rem 1rem', textAlign: 'right' }}>
                            <button
                              onClick={() => handleUnlock(item.ip)}
                              style={{
                                padding: '0.375rem 0.75rem',
                                borderRadius: '8px',
                                background: 'rgba(16, 185, 129, 0.2)',
                                border: '1px solid rgba(16, 185, 129, 0.3)',
                                color: '#34d399',
                                fontSize: '0.75rem',
                                fontWeight: '500',
                                cursor: 'pointer',
                              }}
                            >
                              Entsperren / Zurücksetzen
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ========== EVENTS SECTION ========== */}
          {activeSection === 'events' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>Event-Steuerung</h2>
                <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.25rem 0 0 0' }}>Wähle das aktive saisonale Event</p>
              </div>
              
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '0.75rem' }}>
                {allEvents.map(event => (
                  <button
                    key={event.key}
                    onClick={() => handleEventChange(event.key)}
                    style={{
                      position: 'relative',
                      padding: '1rem',
                      borderRadius: '16px',
                      border: eventSettings.activeEvent === event.key 
                        ? '2px solid #22d3ee'
                        : '2px solid rgba(51, 65, 85, 0.5)',
                      background: eventSettings.activeEvent === event.key
                        ? 'linear-gradient(135deg, rgba(6,182,212,0.2), rgba(37,99,235,0.2))'
                        : 'rgba(30, 41, 59, 0.5)',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      textAlign: 'center',
                    }}
                  >
                    <span style={{ fontSize: '1.875rem', display: 'block', marginBottom: '0.5rem' }}>{event.emoji}</span>
                    <span style={{
                      fontSize: '0.75rem',
                      fontWeight: '500',
                      color: eventSettings.activeEvent === event.key ? '#22d3ee' : '#cbd5e1',
                    }}>
                      {event.label}
                    </span>
                    {eventSettings.activeEvent === event.key && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        background: '#22d3ee',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                      }}>
                        ✓
                      </div>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* ========== EFFECTS SECTION ========== */}
          {activeSection === 'effects' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>Effekt-Intensität</h2>
                <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.25rem 0 0 0' }}>Passe die visuellen Effekte an</p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {/* Snow Slider */}
                <div style={{
                  padding: '1.5rem',
                  borderRadius: '16px',
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(51, 65, 85, 0.5)',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span style={{ fontSize: '1.5rem' }}>❄️</span>
                      <span style={{ fontWeight: '500', color: '#fff' }}>Schnee-Effekt</span>
                    </div>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '9999px',
                      background: 'rgba(6, 182, 212, 0.2)',
                      color: '#22d3ee',
                      fontWeight: 'bold',
                      fontSize: '0.875rem',
                    }}>
                      {eventSettings.snowIntensity || 0}%
                    </span>
                  </div>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={eventSettings.snowIntensity || 0}
                    onChange={(e) => handleIntensityChange('snowIntensity', e.target.value)}
                    style={{ width: '100%', accentColor: '#22d3ee' }}
                  />
                </div>

                {/* Bubble Slider */}
                <div style={{
                  padding: '1.5rem',
                  borderRadius: '16px',
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(51, 65, 85, 0.5)',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span style={{ fontSize: '1.5rem' }}>🫧</span>
                      <span style={{ fontWeight: '500', color: '#fff' }}>Seifenblasen-Effekt</span>
                    </div>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '9999px',
                      background: 'rgba(168, 85, 247, 0.2)',
                      color: '#c084fc',
                      fontWeight: 'bold',
                      fontSize: '0.875rem',
                    }}>
                      {eventSettings.bubbleIntensity || 0}%
                    </span>
                  </div>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={eventSettings.bubbleIntensity || 0}
                    onChange={(e) => handleIntensityChange('bubbleIntensity', e.target.value)}
                    style={{ width: '100%', accentColor: '#a855f7' }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* ========== TARIFFS SECTION ========== */}
          {activeSection === 'tariffs' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>Tarif-Verwaltung</h2>
                <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.25rem 0 0 0' }}>{tariffs.length} Tarife geladen</p>
              </div>
              
              <div style={{
                padding: '2rem',
                borderRadius: '16px',
                background: 'rgba(30, 41, 59, 0.5)',
                border: '1px solid rgba(51, 65, 85, 0.5)',
                textAlign: 'center',
              }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📋</div>
                <p style={{ color: '#cbd5e1', marginBottom: '1rem' }}>Tarife werden über die Hauptansicht bearbeitet.</p>
                <button
                  onClick={handleClose}
                  style={{
                    padding: '0.625rem 1.5rem',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #06b6d4, #2563eb)',
                    color: '#fff',
                    fontWeight: '500',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Zur Tarif-Ansicht
                </button>
              </div>
            </div>
          )}

          {/* ========== SETTINGS SECTION ========== */}
          {activeSection === 'settings' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff', margin: 0 }}>System-Einstellungen</h2>
                <p style={{ fontSize: '0.875rem', color: '#94a3b8', margin: '0.25rem 0 0 0' }}>Globale Konfiguration</p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div style={{
                  padding: '1.5rem',
                  borderRadius: '16px',
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(51, 65, 85, 0.5)',
                }}>
                  <h3 style={{ fontWeight: '600', color: '#fff', marginBottom: '0.5rem' }}>🌐 Server-Status</h3>
                  <p style={{ color: '#94a3b8', fontSize: '0.875rem', margin: 0 }}>Verbindung zur PostgreSQL-Datenbank wird beim Deployment hergestellt.</p>
                </div>
                
                <div style={{
                  padding: '1.5rem',
                  borderRadius: '16px',
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(51, 65, 85, 0.5)',
                }}>
                  <h3 style={{ fontWeight: '600', color: '#fff', marginBottom: '0.5rem' }}>🔐 Authentifizierung</h3>
                  <p style={{ color: '#94a3b8', fontSize: '0.875rem', margin: 0 }}>Session-basierte Authentifizierung über Express-Server.</p>
                </div>

                <div style={{
                  padding: '1.5rem',
                  borderRadius: '16px',
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(51, 65, 85, 0.5)',
                }}>
                  <h3 style={{ fontWeight: '600', color: '#fff', marginBottom: '0.5rem' }}>📊 Version</h3>
                  <p style={{ color: '#94a3b8', fontSize: '0.875rem', margin: 0 }}>TEF Promoter v2.0 — Admin Panel Build</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EventAdminPanel;
